import React, { useState, useRef } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Minimize from '@mui/icons-material/Minimize';
import Toolbar from '@mui/material/Toolbar';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import OpenInFull from '@mui/icons-material/OpenInFull';
import ErrorLogList from './ErrorLogList';

function PaperComponent(props) {
    const nodeRef = useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#error-log-list-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper ref={nodeRef} {...props} />
        </Draggable>
    );
}

const ErrorLogListDialog = ({ onClose }) => {
    const [isFullScreen, setIsFullScreen] = useState(false);

    const handleToggleFullScreen = () => {
        setIsFullScreen(!isFullScreen);
    };

    return (
        <Dialog
            fullScreen={isFullScreen}
            onClose={onClose}
            open={true}
            fullWidth
            maxWidth='md'
            PaperComponent={PaperComponent}
            BackdropProps={{
                sx: {
                    backgroundColor: "rgba(0, 0, 0, 0.2)", // Darker backdrop
                },
            }}
        >
            <Toolbar sx={{ m: 0, p: 0, display: 'flex' }}>
                <DialogTitle id="error-log-list-dialog-title" sx={{ cursor: 'move', flexGrow: 1 }}>
                    Error Log
                </DialogTitle>
                <IconButton onClick={handleToggleFullScreen}>
                    {isFullScreen ? <Minimize /> : <OpenInFull />}
                </IconButton>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Toolbar>
            <DialogContent sx={{
                m: 0,
                p: 0,
                paddingLeft: '20px',
                paddingRight: '20px',
                height: '60vh',
                display: 'flex',
                flexDirection: 'column',
            }}>
                <ErrorLogList />
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ErrorLogListDialog;
